// extracted by mini-css-extract-plugin
export var container = "_6p-0";
export var infoButton = "_6p-1";
export var label = "_6p-3";
export var labelExpanded = "_6p-4";
export var price = "_6p-5";
export var priceExpanded = "_6p-6";
export var title = "_6p-2";